module.exports = __webpack_public_path__ + "static/media/nemesis.be655d06.png";